import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { DesignEngineeringSoftware } from '@indutrust/capability-model';
import { EnvironmentService } from '@indutrust/shared-env';
import { BaseApiClient } from '@indutrust/shared-model';

/**
 * API client for the `design_engineering_softwares` sub-resource nested
 * under a factory capability —
 * `/factories/{factoryId}/capabilities/{capabilityId}/design_engineering_softwares`.
 *
 * Call inherited CRUD methods with
 * `urlSegments: { factoryId: <fid>, capabilityId: <cid> }`.
 */
@Service()
export class DesignEngineeringSoftwareApiClient extends BaseApiClient<DesignEngineeringSoftware> {
  protected envService = inject(EnvironmentService);
  protected http = inject(HttpClient);

  protected template: Partial<DesignEngineeringSoftware> = {};

  get url(): string {
    const base = `${this.envService.getApiUrl()}/factories/{factoryId}`;
    return `${base}/capabilities/{capabilityId}/design_engineering_softwares`;
  }
}
